var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var Check = function (props) { return (React.createElement("svg", __assign({ viewBox: "0 0 903.77 739.84", width: "1em", height: "1em" }, props),
    React.createElement("path", { d: "M291.88 739.84a31.91 31.91 0 0 1-22.63-9.38l-240-240a99.88 99.88 0 0 1 141.26-141.25l16 16a32 32 0 1 1-45.26 45.25l-16-16a35.88 35.88 0 0 0-50.74 50.75l217.37 217.37 537.37-537.37a35.88 35.88 0 0 0-50.74-50.75l-464 464a32 32 0 0 1-45.26 0l-64-64a32 32 0 0 1 45.26-45.25l41.37 41.37L733.25 29.21a99.88 99.88 0 1 1 141.26 141.25l-560 560a31.91 31.91 0 0 1-22.63 9.38z", fill: "currentColor", "data-name": "Layer 2" }))); };
export default Check;
//# sourceMappingURL=Check.js.map